module.exports = __webpack_public_path__ + "static/media/ott-simple-icon.64a3d3d3.svg";